import i18next from 'i18next';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import React from 'react';

const EqualValue = ({fieldName, showLabel, readOnly}) => {
    return <CalculatorSelectInput
      fieldName={`${fieldName}.${0}`}
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      placeholder={i18next.t(
        `calculator.dialog.create.placeholder.selectValues`
      )}
      options={[
        { value: 'true', label: i18next.t('yes') },
        { value: 'false', label: i18next.t('no') },
      ]}
      isRequired
      validate={() => {
        return null;
      }}
      uxVariant="criteriaInput"
      variant="standard"
      labelVariant="chip"
      disabled={readOnly}
      triggerOnContinue
    />
}

export default EqualValue;